import {graphql, useStaticQuery} from "gatsby"

/**
 * @returns {{
 *  title?: string
 * }}
 */
const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return data.site.siteMetadata
}

export default useSiteMetadata
